/* eslint-disable array-callback-return */
/*global google*/

import React, { Component } from "react";
import { compose, withProps } from "recompose";

import {
  DirectionsRenderer,
  GoogleMap,
  Marker,
  withGoogleMap,
  withScriptjs,
} from "react-google-maps";
import moment from "moment";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Input,
  Label,
  Button,
  Form,
} from "reactstrap";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import DatePicker from "react-datepicker";
import { nameValidation, numberValidation } from "../../utils/helperFunction";
import { fetchQueryParams } from "../../utils/comman";
import { toast } from "react-toastify";
import get from "lodash/get";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-react";

import history from "../../history";
import CustomDatepicker from "../CustomDatepicker";
import CustomButton from "../CustomButton";
import CartTitle from "../CartTitle";
import InputText from "../InputText";
import Loader from "../Loader";
import ImageSection from "../ImageSection";

import Config from "../../utils/config";

import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";

const _ = { get };

const rideStatus = ["Upcoming", "Ongoing", "Completed", "Cancelled"];

const rideType = ["Full-Day Rides", "Half-Day Rides", "Multi-Day Tours"];

export default class RideCreation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rideId: "",
      rideName: "",
      startPoint: "",
      sourceLatitude: "",
      sourceLongitude: "",
      destination: "",
      destinationLatitude: "",
      destinationLongitude: "",
      rideStatus: "Upcoming",
      rideStartDate: "",
      rideEndDate: "",
      distanceToAndFro: 0,
      description: "",
      terrainType: "",
      rideLevel: "",
      difficultyLevel: "",
      assemblingTime: "",
      tripDuration: "",
      country: "",
      state: "",
      city: "",
      lastDateOfRegistration: "",
      campaignCode: "",
      rideChampion: "",
      rideChampionMobile: "",
      registrationFee: "",
      totalRegistrationsReceived: "",
      totalRideParticipatedCount: "",
      locality: "",
      userMaxCount: "",
      image: [
        {
          Image: null,
          preview: null,
        },
        {
          Image: null,
          preview: null,
        },
        {
          Image: null,
          preview: null,
        },
        {
          Image: null,
          preview: null,
        },
        {
          Image: null,
          preview: null,
        },
      ],
      wayPoints: [],
      directions: "",
      totalDistance: 0,
      finalTotalDist: 0,
      markers: false,
      transformedData: "",
      wayPointsDist: [],
      actualDistance: "",
      redirectionalUrl: "",
    };
  }

  componentDidMount() {
    if (this.props.page !== "create") {
      let queryParams = this.props.query;
      if (queryParams === "") {
        history.push(`/rides/list`);
      } else {
        if (this.props.singleRide === null) {
          const params = fetchQueryParams(queryParams);
          this.props.handleFetchSingleRide(params.id);
        } else {
          this.handleUpdateForm();
        }
      }
    }
    // this.state.lastDateOfRegistration = moment().toDate();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.singleRide !== null &&
      this.props.singleRide !== prevProps.singleRide
    ) {
      if (this.props.page !== "create") {
        this.handleUpdateForm();
      } else {
        this.setStateToInitial();
      }
    }

    const directionsService = new google.maps.DirectionsService();
    let state = this.state;

    let origin = new google.maps.LatLng(
      state.sourceLatitude,
      state.sourceLongitude
    );
    let destination = new google.maps.LatLng(
      state.destinationLatitude,
      state.destinationLongitude
    );
    const waypoints = state.wayPoints.map((p) => ({
      location: p.name,
      stopover: true,
    }));
    directionsService.route(
      {
        origin: origin,
        destination: destination,
        travelMode: google.maps.TravelMode.DRIVING,
        waypoints: waypoints,
      },
      (response, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          if (waypoints.length > 0) {
            var state = this.state;
            var totalWayPointsDist = 0;
            response.routes[0].legs.map((dist) => {
              totalWayPointsDist = totalWayPointsDist + dist.distance.value;
              state.totalDistance = totalWayPointsDist;
            });
          } else {
            let state = this.state;
            let distance = response.routes[0].legs[0].distance.value;
            state.totalDistance = distance;
          }
          let distanceInKm = this.state.totalDistance / 1000;
          let distanceInKmWithoutDecimal = parseInt(distanceInKm.toFixed());
          this.setState({
            directions: { ...response },
            markers: true,
            distanceToAndFro: distanceInKmWithoutDecimal,
          });
        } else {
          console.error(`error fetching directions ${response}`);
        }
      }
    );
  }

  handleDescriptionChange = (e, editor) => {
    const data = editor.getData();
    this.setState({ description: data });
  };

  handleDescriptionSetData = (editor) => {
    editor.setData(this.state.description);
  };

  setStateToInitial() {
    let state = this.state;
    state.rideId = "";
    state.rideName = "";
    state.startPoint = "";
    state.sourceLatitude = "";
    state.sourceLongitude = "";
    state.destination = "";
    state.destinationLatitude = "";
    state.destinationLongitude = "";
    state.rideStatus = "";
    state.rideStartDate = "";
    state.rideEndDate = "";
    state.distanceToAndFro = "";
    // state.description = "";
    state.terrainType = "";
    state.rideLevel = "";
    state.difficultyLevel = "";
    state.assemblingTime = "";
    state.tripDuration = "";
    state.country = "";
    state.state = "";
    state.city = "";
    state.lastDateOfRegistration = "";
    state.campaignCode = "";
    state.rideChampion = "";
    state.rideChampionMobile = "";
    state.registrationFee = "";
    state.totalRegistrationsReceived = "";
    state.totalRideParticipatedCount = "";
    state.locality = "";
    state.userMaxCount = "";
    state.actualDistance = "";
    this.setState({ ...state });
  }

  addData = () => {
    const transformedData = this.props.states.map((obj) => ({
      ...obj,
      others: "value",
    }));
    console.log(transformedData);
  };

  handleUpdateForm = () => {
    let state = this.state;
    let { singleRide } = this.props;
    state.rideId = singleRide._id;
    state.rideName = singleRide.rideName;
    state.startPoint = singleRide.startPoint.name;
    state.sourceLatitude = singleRide.startPoint.latitude;
    state.sourceLongitude = singleRide.startPoint.longitude;
    state.destination = singleRide.endPoint.name;
    state.destinationLatitude = singleRide.endPoint.latitude;
    state.destinationLongitude = singleRide.endPoint.longitude;
    state.rideStatus = singleRide.rideStatus;
    state.rideStartDate = new Date(singleRide.rideInfo.rideStartDateIso);
    state.rideEndDate = new Date(singleRide.rideInfo.rideEndDateIso);
    state.distanceToAndFro = singleRide.rideInfo.totalDistance;
    state.actualDistance = singleRide.rideInfo.totalDistance;
    state.description = singleRide.rideInfo.rideDetails;
    state.terrainType = singleRide.rideInfo.terrainType;
    state.rideLevel = singleRide.rideInfo.rideLevel;
    state.difficultyLevel = singleRide.rideInfo.difficulty;
    state.assemblingTime = new Date(singleRide.rideInfo.assemblingTime);
    state.tripDuration = singleRide.rideInfo.durationInDays;
    state.country = singleRide.rideInfo.country;
    state.state = singleRide.rideInfo.state;
    state.city = singleRide.rideInfo.city;
    state.lastDateOfRegistration = new Date(singleRide.registrationCutOffDate);
    state.campaignCode = singleRide.campaignCode;
    state.rideChampion = singleRide.rideChampion;
    state.rideChampionMobile = singleRide.rideChampionMobile;
    state.registrationFee =
      singleRide.registrationFee !== "N/A" ? singleRide.registrationFee : "";
    state.locality = singleRide.locality;
    state.userMaxCount = singleRide.allocatedRiderCount;
    state.wayPoints = singleRide.waypoints;
    state.redirectionalUrl = singleRide.registrationUrl;
    this.setState({ ...state });
  };

  handleChange = (e, id) => {
    let state = this.state;
    let value = e.target.value;
    if (id === "name") {
      if (value.match(nameValidation)) {
        state[e.target.name] = value;
        console.log(e.target.value);
      }
    }
    if (id === "number") {
      if (value.match(numberValidation)) {
        state[e.target.name] = value;
      }
    }
    if (id === "all") {
      state[e.target.name] = value;
    }
    this.setState({ ...state });
  };

  handleGoBack = () => {
    if (this.props.page === "create") {
      history.push("/rides/list");
    }
    if (this.props.page === "update") {
      let queryParams = this.props.query;
      const params = fetchQueryParams(queryParams);
      history.push(`/rides/list`);
    }
    if (this.props.page === "ride-update") {
      let queryParams = this.props.query;
      const params = fetchQueryParams(queryParams);
      history.push(`/rides/moderation?status=${params.status}`);
    }
  };

  handleUploadImageSection = () => {
    let state = this.state;
    state.toggleUploadImageSection = !state.toggleUploadImageSection;
    this.setState({ ...state });
  };

  handleChangeStartingLocation = (startPoint) => {
    this.setState({ startPoint });
  };

  handleSelectGeoAddressForStartPoint = (startPoint) => {
    this.setState({ startPoint: startPoint });
    geocodeByAddress(startPoint)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        this.setState({
          sourceLatitude: lat,
          sourceLongitude: lng,
          actualDistance: "",
        });
      })
      .catch((error) => console.error("Error", error));
  };

  handleSelectGeoAddressForEndPoint = (destination) => {
    this.setState({ destination: destination });

    geocodeByAddress(destination)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        this.setState({
          destinationLatitude: lat,
          destinationLongitude: lng,
          actualDistance: "",
        });
      })
      .catch((error) => console.error("Error", error));
  };

  async handleSelectGeoAddressForWayPoint(evt, idx) {
    try {
      let [found] = await geocodeByAddress(evt);
      let { formatted_address } = found;
      let { lat, lng } = await getLatLng(found);

      let state = this.state;
      state.wayPoints[idx] = {
        name: formatted_address,
        latitude: lat,
        longitude: lng,
      };
      state.wayPointsDist[idx] = { latitude: lat, longitude: lng };
      state.actualDistance = "";
      this.setState({ ...state });
    } catch (error) {}
  }

  handleWayPointChange = (evt, idx) => {
    let state = this.state;
    state.wayPoints[idx].name = evt;
    this.setState({ ...state });
  };

  handleAddNewWayPoints = () => {
    this.setState({
      wayPoints: this.state.wayPoints.concat([
        { name: "", latitude: "", longitude: "" },
      ]),
    });
  };

  handleRemoveWayPoints = (idx) => () => {
    this.setState({
      wayPoints: this.state.wayPoints.filter((s, sidx) => idx !== sidx),
    });
  };

  handleChangeEndingLocation = (destination) => {
    this.setState({ destination });
  };

  handleStatusChange = (e, id) => {
    let state = this.state;
    state.difficultyLevel = id;
    this.setState({ ...state });
  };

  handleRideDate = (date, id) => {
    let state = this.state;
    if (id === "start") {
      console.log("Cheking start date", date, typeof date);
      const shouldEndDateReset = moment(date).isSameOrAfter(state.rideEndDate);
      const shouldRegistrationDateReset = moment(date).isSameOrAfter(
        state.lastDateOfRegistration
      );

      if (shouldEndDateReset) {
        state.rideEndDate = date;
      }
      if (shouldRegistrationDateReset) {
        state.lastDateOfRegistration = moment(date).subtract(1, "days")._d;
      }

      state.rideStartDate = date;
      this.setState({ ...state });
    }
    if (id === "end") {
      state.rideEndDate = date;
      this.setState({ ...state });
    }
    if (id === "assembling") {
      state.assemblingTime = date;
      this.setState({ ...state });
    }
    if (id === "lastDate") {
      state.lastDateOfRegistration = date;

      this.setState({ ...state });
    }
  };

  handleChangeRideStatus = (e) => {
    let state = this.state;
    state.rideStatus = e.target.value;
    console.log("dropdown input", e.target.value);
    this.setState({ ...state });
  };

  handleChangeRideType = (e) => {
    let state = this.state;
    state.rideLevel = e.target.value;
    this.setState({ ...state });
  };

  handleCountryChange = (e) => {
    let state = this.state;
    let parsedValue = JSON.parse(e.target.value);
    if (e.target.value !== "Select Country") {
      state.country = parsedValue.country;
      state.countryCode = parsedValue.locality.country;
      state.locality = parsedValue.locality;
      state.state = "";
      state.city = "";
    }
    this.setState({ ...state });
    this.props.handleFetchState(state.countryCode.toUpperCase());
  };

  handleStateChange = (e) => {
    let state = this.state;
    let parsedValue = JSON.parse(e.target.value);
    if (e.target.value !== "Select Country") {
      state.state = parsedValue.name;
      state.city = "";
    }
    this.setState({ ...state });
    let data = {
      countryCode: state.countryCode.toUpperCase(),
      state: state.state,
    };
    this.props.handleFetchCity(data);
  };

  handleCityChange = (e) => {
    let state = this.state;
    let parsedValue = JSON.parse(e.target.value);
    if (e.target.value !== "Select Country") {
      state.city = parsedValue.name;
    }
    this.setState({ ...state });
  };

  handleImageChange = (_id) => (e) => {
    e.preventDefault();
    var fileTypes = ["jpg", "jpeg", "png"];
    if (e.target.files[0]) {
      var extension = e.target.files[0].name
          .split(".")
          .pop()
          .toLowerCase(), //file extension from input file
        isSuccess = fileTypes.indexOf(extension) > -1;
      if (isSuccess) {
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
          this.saveUnitConfigImage(reader.result, file, _id);
        };
        reader.readAsDataURL(file);
      } else {
        this.handleToast(
          "only '.jpg' , '.jpeg' , '.png' file types are accepted"
        );
      }
    } else {
    }
    e.target.value = "";
  };

  changeState = (e) => {
    this.setState({ state: e.target.value });
  };

  changeCity = (e) => {
    this.setState({ city: e.target.value });
  };

  changeFee = (e) => {
    this.setState({ registrationFee: e.target.value });
  };

  changeDistance = (e) => {
    this.setState({ actualDistance: e.target.value });
  };

  handleSubmitForm = (e) => {
    e.preventDefault();
    let { elements } = this.props;
    console.log("Elements", elements);
    let state = this.state;
    let data = {
      rideId: state.rideId,
      rideName: state.rideName ? state.rideName.trim() : "",
      startPoint: state.startPoint,
      sourceLatitude: state.sourceLatitude,
      sourceLongitude: state.sourceLongitude,
      destination: state.destination,
      destinationLatitude: state.destinationLatitude,
      destinationLongitude: state.destinationLongitude,
      rideStatus: state.rideStatus,
      rideStartDate: moment(state.rideStartDate).format("YYYY-MM-DD"),
      rideEndDate: moment(state.rideEndDate).format("YYYY-MM-DD"),
      distanceToAndFro:
        state.actualDistance !== ""
          ? state.actualDistance
          : state.distanceToAndFro,
      description: state.description,
      terrainType: state.terrainType,
      rideLevel: state.rideLevel,
      difficultyLevel: state.difficultyLevel,
      assemblingTime: moment(state.assemblingTime).format(),
      tripDuration: state.tripDuration,
      country: state.country,
      state: state.state,
      city: state.city,
      lastDateOfRegistration: moment(state.lastDateOfRegistration).format(
        "YYYY-MM-DD"
      ),
      campaignCode: state.campaignCode,
      rideChampion: state.rideChampion ? state.rideChampion.trim() : "",
      rideChampionMobile: state.rideChampionMobile,
      registrationFee:
        state.registrationFee !== "" ? state.registrationFee : "N/A",
      totalRegistrationsReceived: state.totalRegistrationsReceived,
      totalRideParticipatedCount: state.totalRideParticipatedCount,
      locality: JSON.stringify(state.locality),
      allocatedRiderCount: state.userMaxCount,
      waypoints: state.wayPoints,
      redirectionalUrl: state.redirectionalUrl,
    };

    if (state.rideName === "")
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.rideNameValidationElement",
          "Enter Ride Name"
        )
      );

    if (state.rideStartDate === "")
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.rideStartDateValidationElement",
          "Select Ride Start Date"
        )
      );
    if (state.rideEndDate === "")
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.rideEndDateValidationElement",
          "Select Ride End Date"
        )
      );
    if (state.startPoint === "")
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.startPointValidationElement",
          "Select Start Point"
        )
      );
    if (state.sourceLatitude === "")
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.startPointValidationElement",
          "Select Start Point"
        )
      );
    if (state.destination === "")
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.endPointValidationElement",
          "Select End Point"
        )
      );
    if (state.destinationLatitude === "")
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.endPointValidationElement",
          "Select End Point"
        )
      );
    if (state.rideStartDate === "")
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.rideStartDateValidationElement",
          "Select Ride Start Date"
        )
      );
    if (state.rideEndDate === "" || state.rideEndDate === null)
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.rideEndDateValidationElement",
          "Select Ride End Date"
        )
      );

    if (state.distanceToAndFro === "")
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.totalDistanceValidationElement",
          "Enter Total Distance"
        )
      );

    if (state.rideLevel === "")
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.rideTypeValidationElement",
          "Enter Ride Type"
        )
      );
    if (state.rideStatus === "")
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.rideStatusValidationElement",
          "Select Ride Status"
        )
      );
    if (state.assemblingTime === "")
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.startTimeValidationElement",
          "Select Start Time"
        )
      );

    if (state.country === "")
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.countryValidationElement",
          "Select Country"
        )
      );
    if (state.state === "")
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.stateValidationElement",
          "Select State"
        )
      );
    if (state.city === "")
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.cityValidationElement",
          "Select City"
        )
      );
    if (
      state.lastDateOfRegistration === "" ||
      state.lastDateOfRegistration === null
    )
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.registrationDateValidationElement",
          "Select last Date of Registration"
        )
      );

    if (state.userMaxCount === "")
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.userMaxCountValidationElement",
          "Enter Rides Capacity"
        )
      );

    if (state.description.length >= 2500)
      return toast.error(
        _.get(
          elements,
          "rideCreateElement.descriptionCharValidationElement",
          "Description Should be of 2500 characters"
        )
      );

    if (this.props.page === "update") return this.props.handleUpdateRide(data);
    if (this.props.page === "ride-update")
      return this.props.handleUpdateRideAdmin(data);

    return this.props.handleCreateRide(data);
  };

  render() {
    let { elements } = this.props;
    const renderFunc = ({
      getInputProps,
      suggestions,
      getSuggestionItemProps,
      loading,
    }) => (
      <div>
        <Input
          className="input-text"
          {...getInputProps({
            placeholder: _.get(
              elements,
              "rideCreateElement.searchPlacesElement",
              "Search Places ..."
            ),
          })}
        />
        <div className="autocomplete-dropdown-container">
          {loading && <div>Loading...</div>}
          {suggestions.map((suggestion) => {
            const className = suggestion.active
              ? "suggestion-item"
              : "suggestion-item";
            const style = suggestion.active
              ? { backgroundColor: "#fafafa", cursor: "pointer" }
              : { backgroundColor: "#ffffff", cursor: "pointer" };
            return (
              <div
                {...getSuggestionItemProps(suggestion, {
                  className,
                  style,
                })}
              >
                <span>{suggestion.description}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
    return (
      <React.Fragment>
        {this.props.page !== "update" && this.props.page !== "ride-update" ? (
          this.props.createRideStatus !== false ? (
            <Loader />
          ) : null
        ) : this.props.updateRideStatus !== false ? (
          <Loader />
        ) : null}
        <div className="hideSearch">
          <Row>
            <Col sm={12}>
              <CartTitle
                title={_.get(
                  elements,
                  "rideCreateElement.headingElement",
                  "Rider Application"
                )}
                Name={"Search"}
                customClass={"hidebtn"}
                iconClass={"hideexcel"}
                innerTextClass={"hidetext"}
              />
            </Col>
          </Row>

          <Form onSubmit={this.handleSubmitForm}>
            <Card className="mb-3">
              <CardBody>
                <Row>
                  <Col md="12"></Col>

                  <Col xl={4} lg={4} md={6} sm={6} className="mb-2">
                    <InputText
                      labelName={_.get(
                        elements,
                        "rideCreateElement.rideNameLabelElement",
                        "Ride Name"
                      )}
                      inputType={"text"}
                      inputName={"rideName"}
                      InputClass={"inputText"}
                      inputPlaceholder={_.get(
                        elements,
                        "rideCreateElement.rideNamePlaceHolderElement",
                        "Ride Name"
                      )}
                      customValue={this.state.rideName}
                      customMaxLength={75}
                      customOnChange={(e) => this.handleChange(e, "name")}
                    />
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={6} className="mb-2">
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "rideCreateElement.rideStartDateLabelElement",
                        "Ride Start Date"
                      )}
                    </Label>
                    <FormGroup className="">
                      <CustomDatepicker
                        value={this.state.rideStartDate}
                        customPlaceHolder={_.get(
                          elements,
                          "rideCreateElement.rideStartDatePlaceHolderElement",
                          "Ride Start Date"
                        )}
                        handleDateChange={(e) =>
                          this.handleRideDate(e, "start")
                        }
                        customShowMonthDropdown={true}
                        customShowYearDropdown={true}
                        customMinDate={new Date()}
                      />
                    </FormGroup>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={6} className="mb-2">
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "rideCreateElement.rideEndDateLabelElement",
                        "Ride End Date"
                      )}
                    </Label>
                    <FormGroup className="">
                      <CustomDatepicker
                        value={this.state.rideEndDate}
                        customPlaceHolder={_.get(
                          elements,
                          "rideCreateElement.rideEndDatePlaceHolderElement",
                          "Ride End Date"
                        )}
                        handleDateChange={(e) => this.handleRideDate(e, "end")}
                        customShowMonthDropdown={true}
                        customShowYearDropdown={true}
                        customMinDate={this.state.rideStartDate}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xl={4} lg={4} md={6} sm={6} className="mb-2">
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "rideCreateElement.startPointLabelElement",
                        "Start Point"
                      )}
                    </Label>
                    <FormGroup className="position-relative">
                      <PlacesAutocomplete
                        value={this.state.startPoint}
                        onChange={(startPoint) =>
                          this.handleChangeStartingLocation(startPoint)
                        }
                        onSelect={(startPoint) =>
                          this.handleSelectGeoAddressForStartPoint(startPoint)
                        }
                      >
                        {renderFunc}
                      </PlacesAutocomplete>
                    </FormGroup>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={6} className="mb-2">
                    <InputText
                      labelName={_.get(
                        elements,
                        "rideCreateElement.sourceLatLabelElement",
                        "Source Latitude"
                      )}
                      style={{ backgroundColor: "#ced4da" }}
                      inputType={"text"}
                      inputName={"sourceLatitude"}
                      InputClass={" inputText"}
                      customValue={this.state.sourceLatitude}
                      disabledType={true}
                      inputPlaceholder={_.get(
                        elements,
                        "rideCreateElement.sourceLatPlaceHolderElement",
                        "Source Latitude"
                      )}
                    />
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={6} className="mb-2">
                    <InputText
                      labelName={_.get(
                        elements,
                        "rideCreateElement.sourceLongLabelElement",
                        "Source Longitude"
                      )}
                      style={{ backgroundColor: "#ced4da" }}
                      inputType={"text"}
                      disabledType={true}
                      inputName={"sourceLongitude"}
                      InputClass={"inputText"}
                      customValue={this.state.sourceLongitude}
                      inputPlaceholder={_.get(
                        elements,
                        "rideCreateElement.sourceLongPlaceHolderElement",
                        "Source Longitude"
                      )}
                    />
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={6} className="mb-2">
                    <FormGroup className="position-relative ">
                      <Label for="exampleNumber" className="inputLabel">
                        {_.get(
                          elements,
                          "rideCreateElement.endPointLabelElement",
                          "End Point"
                        )}
                      </Label>
                      <PlacesAutocomplete
                        value={this.state.destination}
                        onChange={(endPoint) =>
                          this.handleChangeEndingLocation(endPoint)
                        }
                        onSelect={(endPoint) =>
                          this.handleSelectGeoAddressForEndPoint(endPoint)
                        }
                      >
                        {renderFunc}
                      </PlacesAutocomplete>
                    </FormGroup>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={6} className="mb-2">
                    <InputText
                      labelName={_.get(
                        elements,
                        "rideCreateElement.destinationLatLabelElement",
                        "Destination Latitude"
                      )}
                      style={{ backgroundColor: "#ced4da" }}
                      inputType={"text"}
                      disabledType={true}
                      inputName={"destinationLatitude"}
                      InputClass={" inputText"}
                      customValue={this.state.destinationLatitude}
                      inputPlaceholder={_.get(
                        elements,
                        "rideCreateElement.destinationLatPlaceHolderElement",
                        "Destination Latitude"
                      )}
                    />
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={6} className="mb-2">
                    <InputText
                      labelName={_.get(
                        elements,
                        "rideCreateElement.destinationLongLabelElement",
                        "Destination Longitude"
                      )}
                      style={{ backgroundColor: "#ced4da" }}
                      inputType={"text"}
                      inputName={"destinationLongitude"}
                      InputClass={"inputText"}
                      disabledType={true}
                      customValue={this.state.destinationLongitude}
                      inputPlaceholder={_.get(
                        elements,
                        "rideCreateElement.destinationLongPlaceHolderElement",
                        "Destination Longitude"
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={12} lg={12} md={12} sm={12}>
                    <Label className="inputLabel" for="--">
                      {_.get(
                        elements,
                        "rideCreateElement.wayPointsLabelElement",
                        "Way Points"
                      )}
                    </Label>
                    <FormGroup
                      className={`my-2 w-100 addSection ${
                        this.state.wayPoints.length === 0 ? " " : "active"
                      }`}
                    >
                      <div className="addWayPointContaier">
                        <Row>
                          {this.state.wayPoints.map((wayPoint, idx) => (
                            <Col md="4">
                              <div
                                key={idx}
                                className="d-flex w-100 addWayPoint"
                              >
                                <PlacesAutocomplete
                                  value={wayPoint.name}
                                  onChange={(evt) =>
                                    this.handleWayPointChange(evt, idx)
                                  }
                                  onSelect={(evt) =>
                                    this.handleSelectGeoAddressForWayPoint(
                                      evt,
                                      idx
                                    )
                                  }
                                >
                                  {renderFunc}
                                </PlacesAutocomplete>
                                <Button
                                  onClick={this.handleRemoveWayPoints(idx)}
                                  className="waypoint_small_button closeBtn"
                                >
                                  x
                                </Button>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </div>
                      {this.state.wayPoints.length < 20 ? (
                        <div className="d-flex justify-content-start btnContainer">
                          <Button
                            onClick={() => this.handleAddNewWayPoints()}
                            className="waypoint_small_button"
                          >
                            {_.get(
                              elements,
                              "rideCreateElement.addWayPointsButtonElement",
                              "Add Way Point"
                            )}
                          </Button>
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xl={3} lg={4} md={6} sm={6}>
                    <InputText
                      labelName={_.get(
                        elements,
                        "rideCreateElement.tripDurationLabelElement",
                        "Trip Duration (In Hours)"
                      )}
                      inputType={"text"}
                      inputName={"tripDuration"}
                      InputClass={"inputText"}
                      customValue={this.state.tripDuration}
                      inputPlaceholder={_.get(
                        elements,
                        "rideCreateElement.tripDurationPlaceHolderElement",
                        "Trip Duration"
                      )}
                      customMaxLength={10}
                      customMinLength={1}
                      customOnChange={(e) => this.handleChange(e, "number")}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6}>
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "rideCreateElement.totalDistanceLabelElement",
                        "Calculated distance (in km)"
                      )}
                    </Label>
                    <FormGroup>
                      <input
                        type="text"
                        name="distanceToAndFro"
                        placeholder={_.get(
                          elements,
                          "rideCreateElement.totalDistancePlaceHolderElement",
                          "Distance"
                        )}
                        maxlength="20"
                        autoComplete="off"
                        className=" form-control"
                        value={this.state.distanceToAndFro}
                        disabled
                      />
                    </FormGroup>
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6}>
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "rideCreateElement.actualDistanceLabelElement",
                        "Actual distance (in km)"
                      )}
                    </Label>
                    <FormGroup>
                      <input
                        type="text"
                        name="actualDistance"
                        placeholder={_.get(
                          elements,
                          "rideCreateElement.actualDistancePlaceHolderElement",
                          "Actual Distance"
                        )}
                        maxlength="20"
                        autoComplete="off"
                        className=" form-control"
                        value={this.state.actualDistance}
                        onChange={this.changeDistance}
                      />
                    </FormGroup>
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6}>
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "rideCreateElement.rideLevelLabelElement",
                        "Ride Type"
                      )}{" "}
                    </Label>
                    <FormGroup className=" confirmRiderSelect select_options">
                      <Input
                        type="select"
                        name="branchType"
                        className="w-100 customeSelectBtn"
                        onChange={this.handleChangeRideType}
                      >
                        <option selected="true" disabled="disabled">
                          {this.props.page !== "create"
                            ? this.state.rideLevel
                            : _.get(
                                elements,
                                "rideCreateElement.selectRideTypeElement",
                                "Select Type"
                              )}
                        </option>
                        {rideType.map((item, index) => (
                          <option key={index} value={item}>
                            {" "}
                            {item}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6}>
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "rideCreateElement.rideStatusElement",
                        "Ride Status"
                      )}{" "}
                    </Label>
                    <FormGroup className=" confirmRiderSelect select_options">
                      <Input
                        type="select"
                        name="branchType"
                        className="w-100 customeSelectBtn"
                        onChange={this.handleChangeRideStatus}
                        value={this.state.rideStatus}
                      >
                        {rideStatus.map((item, index) => (
                          <option key={index} value={item}>
                            {" "}
                            {item}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-3 mb-lg-0">
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "rideCreateElement.assemblingTimeLabelElement",
                        "Start Time"
                      )}{" "}
                    </Label>
                    <FormGroup className=" inputWrpper customDatepicker">
                      <DatePicker
                        onChange={(e) => this.handleRideDate(e, "assembling")}
                        className={"form-control dateSpace"}
                        timeIntervals={15}
                        timeCaption="Time"
                        dateFormat="h:mm aa"
                        placeholderText={_.get(
                          elements,
                          "rideCreateElement.assemblingTimePlaceHolderElement",
                          "Start Time"
                        )}
                        selected={this.state.assemblingTime}
                        showTimeSelect
                        showTimeSelectOnly
                      />
                    </FormGroup>
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6}>
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "rideCreateElement.countryLabelElement",
                        "Country"
                      )}{" "}
                    </Label>
                    <FormGroup className=" confirmRiderSelect select_options">
                      <Input
                        type="select"
                        name="City"
                        className="w-100 customeSelectBtn"
                        onChange={this.handleCountryChange}
                      >
                        <option selected="true" disabled="disabled">
                          {this.state.country !== ""
                            ? this.state.country
                            : _.get(
                                elements,
                                "userCreationElements.selectCountryElement",
                                "Select Country"
                              )}
                        </option>
                        {this.props.countries.map((item, index) => (
                          <option key={index} value={JSON.stringify(item)}>
                            {item.country}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6}>
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "rideCreateElement.stateLabelElement",
                        "State*"
                      )}
                    </Label>
                    <FormGroup>
                      {" "}
                      <input
                        type="text"
                        name="state"
                        placeholder={_.get(
                          elements,
                          "rideCreateElement.statePlaceHolderElement",
                          "Enter State"
                        )}
                        maxlength="100"
                        autoComplete="off"
                        className="form-control"
                        value={this.state.state}
                        onChange={this.changeState}
                      />
                    </FormGroup>
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6}>
                    <Label className="inputLabel">
                      {" "}
                      {_.get(
                        elements,
                        "rideCreateElement.cityLabelElement",
                        "City*"
                      )}
                    </Label>
                    <FormGroup>
                      <input
                        type="text"
                        name="city"
                        placeholder={_.get(
                          elements,
                          "rideCreateElement.cityPlaceHolderElementRide",
                          "Enter City"
                        )}
                        maxlength="100"
                        autoComplete="off"
                        className="form-control"
                        value={this.state.city}
                        onChange={this.changeCity}
                      />
                    </FormGroup>
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-3 mb-lg-0">
                    <Label className="inputLabel">
                      {_.get(
                        elements,
                        "rideCreateElement.lastDateRegisterLabelElement",
                        "Last Date of Registration"
                      )}
                    </Label>
                    <FormGroup className="">
                      <CustomDatepicker
                        value={this.state.lastDateOfRegistration}
                        customPlaceHolder={_.get(
                          elements,
                          "rideCreateElement.lastDateRegisterPlaceHolderElement",
                          "Last Date of Registration"
                        )}
                        handleDateChange={(e) =>
                          this.handleRideDate(e, "lastDate")
                        }
                        customShowMonthDropdown={true}
                        customShowYearDropdown={true}
                        customMaxDate={
                          moment(this.state.rideStartDate).subtract(1, "days")
                            ._d
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6}>
                    <InputText
                      labelName={_.get(
                        elements,
                        "rideCreateElement.rideChampionLabelElement",
                        "Ride Coordinator Name"
                      )}
                      inputType={"text"}
                      inputName={"rideChampion"}
                      InputClass={" inputText"}
                      customValue={this.state.rideChampion}
                      inputPlaceholder={_.get(
                        elements,
                        "rideCreateElement.rideChampionPlaceHolderElement",
                        "Ride Coordinator"
                      )}
                      customMaxLength={20}
                      customOnChange={(e) => this.handleChange(e, "name")}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6}>
                    <InputText
                      labelName={_.get(
                        elements,
                        "rideCreateElement.rideChampionMobileLabelElement",
                        "Ride Coordinator Mobile"
                      )}
                      inputType={"tel"}
                      inputName={"rideChampionMobile"}
                      InputClass={"inputText"}
                      customValue={this.state.rideChampionMobile}
                      inputPlaceholder={_.get(
                        elements,
                        "rideCreateElement.rideChampionMobilePlaceHolderElement",
                        "Ride Coordinator Mobile"
                      )}
                      customOnChange={(e) => this.handleChange(e, "number")}
                      customMaxLength={15}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6}>
                    <Label className="inputLabel">
                      {" "}
                      {_.get(
                        elements,
                        "rideCreateElement.registrationFeeLabelElement",
                        "Registration Fee"
                      )}
                    </Label>
                    <FormGroup>
                      <input
                        type="text"
                        name="registrationFee"
                        placeholder={_.get(
                          elements,
                          "rideCreateElement.registrationFeePlaceHolderElement",
                          "Registration Fee"
                        )}
                        maxlength="20"
                        autoComplete="off"
                        className="inputText form-control"
                        value={this.state.registrationFee}
                        onChange={this.changeFee}
                      />
                    </FormGroup>
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6}>
                    <InputText
                      labelName={_.get(
                        elements,
                        "rideCreateElement.userMaxCountElement",
                        "Rides capacity"
                      )}
                      inputType={"tel"}
                      inputName={"userMaxCount"}
                      InputClass={"inputText"}
                      customValue={this.state.userMaxCount}
                      inputPlaceholder={_.get(
                        elements,
                        "rideCreateElement.userMaxCountPlaceHolderElement",
                        "Enter Rides Capacity"
                      )}
                      customMaxLength={7}
                      customOnChange={(e) => this.handleChange(e, "number")}
                    />
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={6}>
                    <InputText
                      labelName={_.get(
                        elements,
                        "rideCreateElement.redirectionalUrl",
                        "Redirection Url"
                      )}
                      inputType={"text"}
                      inputName={"redirectionalUrl"}
                      InputClass={"inputText"}
                      customValue={this.state.redirectionalUrl}
                      inputPlaceholder={_.get(
                        elements,
                        "rideCreateElement.redirectionalUrlPlaceHolderElement",
                        "Enter Link"
                      )}
                      customOnChange={(e) => this.handleChange(e, "all")}
                    />
                  </Col>
                  <Col xl={6} lg={6} md={6} sm={6}>
                    <Label className="inputLabel" for="--">
                      {_.get(
                        elements,
                        "rideCreateElement.descriptionLabelElement",
                        "Description"
                      )}
                    </Label>
                    <FormGroup>
                      <CKEditor
                        editor={ClassicEditor}
                        onInit={(editor) =>
                          this.handleDescriptionSetData(editor)
                        }
                        data={this.state.description}
                        onChange={(e, editor) =>
                          this.handleDescriptionChange(e, editor)
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <MyMapComponent
                      isMarkerShown={true}
                      onMarkerClick={this.handleMarkerClick}
                      values={this.state}
                    />
                  </Col>
                </Row>

                <div className="d-flex justify-content-center justify-content-lg-end position-relative mt-3 ">
                  <CustomButton
                    customType={"button"}
                    name={_.get(
                      elements,
                      "rideCreateElement.backButtonElement",
                      "Back"
                    )}
                    customClass={"btn-outline-dark bg-none btnthemeColor ml-2"}
                    customClick={() => this.handleGoBack()}
                  />
                  <CustomButton
                    customType={"submit"}
                    name={_.get(
                      elements,
                      "rideCreateElement.submitButtonElement",
                      "Submit"
                    )}
                    customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                  />
                </div>
              </CardBody>
            </Card>
          </Form>
        </div>

        <ImageSection
          value={this.state}
          handleUploadImageSection={this.handleUploadImageSection}
        />
      </React.Fragment>
    );
  }
}

const MyMapComponent = compose(
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyCb_eIYqj93ZiAqN5AQiyWWn4RsjXjlglQ",
    loadingElement: <div style={{ height: "100%" }} />,
    containerElement: <div style={{ height: `500px`, width: "100%" }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)((props) => (
  <GoogleMap
    defaultZoom={4}
    defaultCenter={{ lat: 51.5073509, lng: -0.1277583 }}
  >
    <div>
      <Marker
        icon={`${Config.imageBaseUrl}/content/dam/re-platform-images/maps/rides-start-point.png`}
        position={
          new window.google.maps.LatLng(
            props.values.sourceLatitude,
            props.values.sourceLongitude
          )
        }
        suppressMarkers={true}
      />
      <Marker
        icon={`${Config.imageBaseUrl}/content/dam/re-platform-images/maps/rides-end-point.png`}
        position={
          new window.google.maps.LatLng(
            props.values.destinationLatitude,
            props.values.destinationLongitude
          )
        }
        suppressMarkers={true}
      />
    </div>

    {props.values.wayPoints.length !== 0
      ? props.values.wayPoints.map((item) => (
          <Marker
            icon={`${Config.imageBaseUrl}/content/dam/re-platform-images/maps/Live-tracker-rides.png`}
            position={
              new window.google.maps.LatLng(item.latitude, item.longitude)
            }
            suppressMarkers={true}
          />
        ))
      : null}

    <DirectionsRenderer
      directions={props.values.directions}
      options={{
        polylineOptions: {
          stokeColor: "#FF0000",
          strokeOpacity: 0.5,
          strokeWeight: 4,
        },
        markerOptions: { visible: false },
      }}
      suppressMarkers={true}
    />
  </GoogleMap>
));
